module.exports = __webpack_public_path__ + "static/media/eventos_relevantes.e8fd81a2.svg";